import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const GifIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 32 32"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M20.0231 2.875C20.2147 2.87447 20.4045 2.91196 20.5815 2.98529C20.7586 3.05861 20.9193 3.16633 21.0544 3.30219L26.6875 8.93531C26.8233 9.07043 26.931 9.23114 27.0044 9.40815C27.0777 9.58517 27.1152 9.77496 27.1147 9.96656V27.6666C27.1147 28.4709 26.4538 29.125 25.6416 29.125H6.34812C5.53562 29.125 4.875 28.4709 4.875 27.6666V4.33344C4.875 3.52906 5.53594 2.875 6.34812 2.875H20.0231ZM20.0231 2H6.34812C5.05125 2 4 3.04469 4 4.33344V27.6666C4 28.9553 5.05125 30 6.34812 30H25.6416C26.9384 30 27.9897 28.9553 27.9897 27.6666V9.96656C27.9896 9.34771 27.7438 8.75421 27.3062 8.31656L21.6731 2.68344C21.2355 2.24592 20.642 2.0001 20.0231 2Z"
        fill="currentColor"
      />
      <path
        d="M20 2V7.33344C20.0001 8.04063 20.281 8.71883 20.7811 9.21889C21.2812 9.71895 21.9594 9.99992 22.6666 10H28L20 2Z"
        fill="currentColor"
      />
      <path
        d="M17.7941 26V22.1838H20.3208V22.8491H18.6009V23.7584H20.1531V24.4236H18.6009V26H17.7941Z"
        fill="currentColor"
      />
      <path
        d="M17.1303 22.1838V26H16.3235V22.1838H17.1303Z"
        fill="currentColor"
      />
      <path
        d="M14.8622 23.4174C14.8361 23.3267 14.7994 23.2466 14.7522 23.177C14.705 23.1062 14.6473 23.0466 14.5789 22.9981C14.5119 22.9484 14.4348 22.9105 14.3479 22.8844C14.2622 22.8584 14.1671 22.8453 14.0628 22.8453C13.8678 22.8453 13.6963 22.8938 13.5485 22.9907C13.4019 23.0876 13.2876 23.2285 13.2056 23.4136C13.1237 23.5975 13.0827 23.8223 13.0827 24.0882C13.0827 24.354 13.123 24.5801 13.2038 24.7664C13.2845 24.9528 13.3988 25.095 13.5466 25.1931C13.6945 25.29 13.869 25.3385 14.0702 25.3385C14.2528 25.3385 14.4087 25.3062 14.5379 25.2416C14.6684 25.1758 14.7678 25.0832 14.8361 24.964C14.9056 24.8447 14.9404 24.7037 14.9404 24.541L15.1044 24.5652H14.1205V23.9577H15.7174V24.4385C15.7174 24.7739 15.6466 25.0621 15.505 25.3031C15.3634 25.5428 15.1684 25.7279 14.9199 25.8584C14.6715 25.9876 14.387 26.0522 14.0665 26.0522C13.7087 26.0522 13.3945 25.9733 13.1237 25.8155C12.8528 25.6565 12.6417 25.431 12.4901 25.1391C12.3398 24.8459 12.2646 24.4981 12.2646 24.0956C12.2646 23.7863 12.3094 23.5105 12.3988 23.2683C12.4895 23.0248 12.6162 22.8186 12.7789 22.6497C12.9417 22.4807 13.1311 22.3521 13.3473 22.264C13.5634 22.1758 13.7976 22.1317 14.0497 22.1317C14.2659 22.1317 14.4671 22.1633 14.6535 22.2267C14.8398 22.2888 15.005 22.377 15.1491 22.4913C15.2945 22.6056 15.4131 22.7416 15.505 22.8994C15.5969 23.0559 15.656 23.2285 15.682 23.4174H14.8622Z"
        fill="currentColor"
      />
      <path
        d="M13 16V13.384C13 12.7685 13.666 12.3836 14.1993 12.6908L16.4722 14L18.7651 15.3102C19.3007 15.6162 19.303 16.3877 18.7692 16.697L16.4722 18.0278L14.1993 19.337C13.666 19.6442 13 19.2592 13 18.6438V16Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(GifIcon);
